import { ProductVariantTable } from "../DataTables/ProductVariantTable";
import { CharacteristicsIcons } from "../DataTables/CharacteristicsIcons";
import { Card } from "../../../Configurators/Linear/components/Card";
import PdfDownloadLink from "./components/PdfDownloadLink";
import { type PdpPageProductData } from "../../models/PdpPageProductData";
import { Col, Row } from "../../../common/components/Layout";
import BearingXPdfDownloadLink from "./components/BearingXPdfDownloadLink";
import useMediaQuery from "../../../common/hooks/useMediaQuery";
import RohsPdfDownloadLink from "./components/RohsPdfDownloadLink";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../../../utils/screenSizes";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import { fetchBearingXId } from "~/ProductDetails/components/SpecificationsCard/api/fetchBearingXId";

interface Props {
  product: PdpPageProductData;
}

const VALID_CLASS_FOR_FREQUENCIES = "IDO_CATALOGUE_BEARING";

export const SpecificationsCard = ({ product }: Props) => {
  const [isReady, setIsReady] = useState(false);
  const [bearingXId, setBearingXId] = useState("");
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const { t } = useTranslation();

  useMemo(() => {
    (async () => {
      if (product.showBasicFrequencies && product.bearingXDesignation) {
        const data = await fetchBearingXId(product.bearingXDesignation);
        if (data?.productInfo?.bearinxClass === VALID_CLASS_FOR_FREQUENCIES) {
          setBearingXId(data.productInfo.id);
        }
        setIsReady(true);
      } else {
        setIsReady(true);
      }
    })();
  }, [product.bearingXDesignation, product.showBasicFrequencies]);

  return (
    <>
      {isReady && (
        <Card className={"scha__pdp__specifications-card"} disableHover={true}>
          <Row>
            <Col size={12} className={"scha__pdp__download-title"}>
              {t("productDetailPage.downloads.title")}
            </Col>
            <Col size={12} className={isDesktop ? "pt-2" : ""}>
              <PdfDownloadLink product={product} />
            </Col>
            {product.showBasicFrequencies && !!bearingXId && (
              <Col size={12} className={isDesktop ? "pt-2" : ""}>
                <BearingXPdfDownloadLink product={product} bearingXId={bearingXId} />
              </Col>
            )}
            {product.showRohsDownload && (
              <Col size={12} className={isDesktop ? "pt-2" : ""}>
                <RohsPdfDownloadLink product={product} />
              </Col>
            )}
          </Row>
          {product.specificationBand && product.specificationBand.length > 0 && (
            <ProductVariantTable data={product.specificationBand} />
          )}
          {product.attributeIcons && product.attributeIcons.length > 0 && (
            <CharacteristicsIcons data={product.attributeIcons} />
          )}
        </Card>
      )}
    </>
  );
};
